"use strict";
exports.__esModule = true;
var mapContent = require("../windowsZones.json");
exports.map = mapContent;
//# sourceMappingURL=time-zone-map.js.map